<script>
export default {
    props: {
        context: {},
        cols: {},
        category: {}
    }
};
</script>

<template>
    <modal size="xxl" :show="true" @close="$emit('close')" class="budget-modal">
        <template slot="header">
            {{ $t("stakeholder.import_from_csv") }}
        </template>

        <template slot="default">
            <div class="alert alert-success" v-if="context.imported == true">
                {{ $t("stakeholders.all_data_imported_properly") }}
            </div>
            <div class="alert alert-danger" v-else>
                {{ $t("stakeholder.no_records_imported_review_errors_below") }}
            </div>

            <div class="table-responsive">
                <v-table class="table table-sm">
                    <v-thead>
                        <v-tr>
                            <v-th>
                                {{ $t("stakeholders.tbl_hdr_status") }}
                            </v-th>
                            <v-th
                                v-for="(line, idx) in context.status[0].entry"
                            >
                                {{ $t(`stakeholders.hdr_${idx}`) }}
                            </v-th>
                        </v-tr>
                    </v-thead>
                    <v-tbody>
                        <v-tr v-for="(line, idx) in context.status" :key="idx">
                            <v-td>
                                <i
                                    class="far fa-2x fa-fw"
                                    :class="{
                                        'fa-check text-success':
                                            line.status == 1,
                                        'fa-times text-danger': line.status == 0
                                    }"
                                ></i>
                                <div>
                                    <ul class="list-unstyled">
                                        <li
                                            v-for="(err, idc) in Object.values(
                                                line.error
                                            )"
                                            :key="idx"
                                        >
                                            <div class="text-danger">
                                                {{ Object.values(err)[0] }}
                                            </div>
                                            <div class="text-muted small">
                                                {{ Object.keys(err)[0] }}
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </v-td>
                            <v-td v-for="k in line.entry">
                                {{ k }}
                            </v-td>
                        </v-tr>
                    </v-tbody>
                </v-table>
            </div>
        </template>
    </modal>
</template>
